import React from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import AppBarModal from '../../../../general/AppBarModal';
import DialogAccionesCerrarBienestar from './DialogAccionesCerrarBienestar';
import { BIENESTAR_MODAL_PAPER_FLEX } from '../../helpers/bienestarDetalleConstants';

const PAPER_PROPS = {
    style: {
        ...BIENESTAR_MODAL_PAPER_FLEX,
        minWidth: 0,
    },
};

const CONTENT_STYLE = { flex: '1 1 auto', minHeight: 0, overflowY: 'auto' };

function DialogDetalleDisentimiento({
    open,
    titulo,
    onClose,
    componenteDetalle: ComponenteDetalle,
    datos,
}) {
    if (!open) return null;
    return (
        <Dialog
            open
            maxWidth="sm"
            fullWidth
            scroll="paper"
            onClose={onClose}
            PaperProps={PAPER_PROPS}
        >
            <AppBarModal titulo={titulo} mostrarModal={onClose} titulo_accion="" />
            <DialogContent style={CONTENT_STYLE}>
                <ComponenteDetalle datos={datos} />
            </DialogContent>
            <DialogAccionesCerrarBienestar onClick={onClose} />
        </Dialog>
    );
}

export default React.memo(DialogDetalleDisentimiento);
